import { makeStyles } from "@material-ui/styles";

export default makeStyles(theme => ({
  link: {
    textDecoration: "none",
    "&:hover": {
      backgroundColor: theme.palette.colorSide.light,
    },
    "&:focus": {
      backgroundColor: theme.palette.colorSide.default,
    },
  },
  externalLink: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textDecoration: 'none'
  },
  linkActive: {
    backgroundColor: theme.palette.colorSide.default,
  },
  linkNested: {
    paddingLeft: 0,
    "&:hover": {
      backgroundColor: theme.palette.colorSide.light,
    },
    "&:focus": {
      backgroundColor: theme.palette.colorSide.default,
    },
  },
  linkIcon: {
    marginRight: theme.spacing(1),
    color: "#C0C0C0",
    transition: theme.transitions.create("color"),
    width: 24,
    display: "flex",
    justifyContent: "center",
  },
  linkIconActive: {
    color: "#FFFFFF",
  },
  linkText: {
    padding: 0,
    color: "#C0C0C0",
    transition: theme.transitions.create(["opacity", "color"]),
    fontSize: 16,
  },
  linkTextActive: {
    color: "#FFFFFF",
  },
  linkTextHidden: {
    opacity: 0,
  },
  nestedList: {
    paddingLeft: theme.spacing(2) + 30,
  },
  sectionTitle: {
    marginLeft: theme.spacing(4.5),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  divider: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(4),
    height: 1,
    backgroundColor: "#D8D8D880",
  },
}));
